import classes from "./Analytics.module.scss";
import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {Context} from "../index";
import {checkAuth} from "../http/userAPI";
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import {nullFilter} from "../utils/nullFilter";
import {getCurrent, getHumidity, getTemperature, getVoltage} from "../http/deviceAPI";
import Icon from "@mdi/react";
import {mdiChevronLeft, mdiChevronRight} from "@mdi/js";
import DateAndTimePicker from "../components/DateAndTimePicker";
import {DateTimePicker} from "@mui/x-date-pickers";
import {observer} from "mobx-react-lite";
import ChartStacked from "../components/ChartStacked";


const Analytics = observer(() => {
    const {analytics} = useContext(Context);
    const {user} = useContext(Context);
    const {things} = useContext(Context);
    const {channels} = useContext(Context);
    const navigate = useNavigate();
    const [firstTime, setFirstTime] = useState(dayjs().subtract(7, 'hours'))
    const [lastTime, setLastTime] = useState(dayjs())
    const [diffTime, setDiffTime] = useState(lastTime.diff(firstTime))
    const [maxLastTime, setMaxLastTime] = useState(dayjs())
    const [isVoltage, setIsVoltage] = useState(false)
    const [isCurrent, setIsCurrent] = useState(false)
    const [isTemperature, setIsTemperature] = useState(false)
    const [isHumidity, setIsHumidity] = useState(false)


    let v = [];
    let c = [];
    let t = [];
    let h = [];

    const setRange = () => {
        let d = dayjs(firstTime).add(24, 'hour')
        if (d > dayjs()) {
            d = dayjs()
        }
        setMaxLastTime(d)
    }


    const gv = async (name, firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getVoltage(name, channels.channelId, (firstTime.unix()), lastTime.unix());
            analytics.setTotalVoltage(data.total)
            lt = lastTime
            while (analytics.totalVoltage > 0) {
                const {data} = await getVoltage(name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                analytics.setTotalVoltage(analytics.totalVoltage - data.messages.length)
                v.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: value.toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gi = async (name, firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getCurrent(name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            analytics.setTotalCurrent(data.total)
            lt = lastTime
            while (analytics.totalCurrent > 0) {
                const {data} = await getCurrent(name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                analytics.setTotalCurrent(analytics.totalCurrent - data.messages.length)
                c.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: (value * things.settings.current_factor).toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gt = async (name, firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getTemperature(name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            analytics.setTotalTemperature(data.total)
            lt = lastTime
            while (analytics.totalTemperature > 0) {
                const {data} = await getTemperature(name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                analytics.setTotalTemperature(analytics.totalTemperature - data.messages.length)
                t.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: value.toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gh = async (name, firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getHumidity(name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            analytics.setTotalHumidity(data.total)
            lt = lastTime
            while (analytics.totalHumidity > 0) {
                const {data} = await getHumidity(name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                analytics.setTotalHumidity(analytics.totalHumidity - data.messages.length)
                h.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: value.toFixed(1)
                })))
            }
        } catch (e) {
        }
    }

    // const powerChart = () => {
    //     let power = [];
    //     let item = 0;
    //     for (let i = 0; i < analytics.messages.current.length; i++) {
    //
    //         if (analytics.messages.current[i]?.y === null || analytics.messages.voltage[i]?.y === null) {
    //             item = null
    //         }
    //         if (Math.abs(analytics.messages.current[i]?.y) < 10 && analytics.messages.current[i]?.y != null) {
    //             item = +0
    //         }
    //         if (Math.abs(analytics.messages.current[i]?.y) > 10) {
    //             item = (analytics.messages.current[i]?.y * analytics.messages.voltage[i]?.y).toFixed(1);
    //         }
    //         power.push({x: new Date(analytics.messages.current[i]?.x), y: item})
    //     }
    //     analytics.setMessages('power', power)
    // }

    const load = async () => {
        try {
            const {data} = await checkAuth(user.userId)
            user.setUserId(data.id);
            user.setIsAuth(true);
            user.setUser('email', data.email)
        } catch (e) {
            user.setUserId(null);
            user.setIsAuth(false);
            navigate('/auth')
        }
    }
    const updateFirstTime = (hours) => {
        let d = lastTime.subtract(hours, 'hours')
        setFirstTime(d)
    }
    const [dataVoltage, setDataVoltage] = useState([
        {
            name: '123',
            data: [
                {
                    x: 0,
                    y: 0,
                }, {
                    x: 1,
                    y: 2,
                }, {
                    x: 2,
                    y: 4,
                }
            ]
        },
        {
            name: '123',
            data: [
                {
                    x: 0,
                    y: 4,
                },
                {
                    x: 1,
                    y: 2,
                },
                {
                    x: 2,
                    y: 0,
                },
            ]
        },
    ])

    const chartData = [
        {
            name: 'Напряжение',
            unit: 'В',
            isFetch: isVoltage,
            data: dataVoltage,
            show: isVoltage,
            id: 1
        },
        {
            name: 'Ток',
            unit: 'А',
            isFetch: isVoltage,
            data: [
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 0,
                        }, {
                            x: 1,
                            y: 2,
                        }, {
                            x: 2,
                            y: 4,
                        }
                    ]
                },
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 4,
                        },
                        {
                            x: 1,
                            y: 2,
                        },
                        {
                            x: 2,
                            y: 0,
                        },
                    ]
                },
            ],
            show: isVoltage,
            id: 1
        },
        {
            name: 'Температура',
            unit: '°C',
            isFetch: isVoltage,
            data: [
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 0,
                        }, {
                            x: 1,
                            y: 2,
                        }, {
                            x: 2,
                            y: 4,
                        }
                    ]
                },
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 4,
                        },
                        {
                            x: 1,
                            y: 2,
                        },
                        {
                            x: 2,
                            y: 0,
                        },
                    ]
                },
            ],
            show: isVoltage,
            id: 1
        },
        {
            name: 'Влажность',
            unit: '%',
            isFetch: isVoltage,
            data: [
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 0,
                        }, {
                            x: 1,
                            y: 2,
                        }, {
                            x: 2,
                            y: 4,
                        }
                    ]
                },
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 4,
                        },
                        {
                            x: 1,
                            y: 2,
                        },
                        {
                            x: 2,
                            y: 0,
                        },
                    ]
                },
            ],
            show: isVoltage,
            id: 1
        },
        {
            name: 'Мощность',
            unit: 'Вт',
            isFetch: isVoltage,
            data: [
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 0,
                        }, {
                            x: 1,
                            y: 2,
                        }, {
                            x: 2,
                            y: 4,
                        }
                    ]
                },
                {
                    name: '123',
                    data: [
                        {
                            x: 0,
                            y: 4,
                        },
                        {
                            x: 1,
                            y: 2,
                        },
                        {
                            x: 2,
                            y: 0,
                        },
                    ]
                },
            ],
            show: isVoltage,
            id: 1
        },
    ];

    useEffect(() => {
        load().then(() => {
            if (user.isAuth) {
                setIsVoltage(false)
                setIsCurrent(false)
                setIsTemperature(false)
                setIsHumidity(false)
                v = [];
                c = [];
                t = [];
                h = [];
                setDataVoltage([])
                analytics.fetchList.map((item) => {
                    gv(item.name, firstTime, lastTime).then(() => {
                        setDataVoltage(()=>{
                            return [
                                ...dataVoltage,
                                {
                                    name: item.serialNumber,
                                    data: v,
                                }
                            ]
                        })
                        setIsVoltage(true)
                        // nullFilter(analytics, 'voltage', analytics.messages.voltage)
                        // gi(item.name, firstTime, lastTime).then(() => {
                        //     setChartData(
                        //         [
                        //             ...chartData,
                        //             chartData[1].data.push(
                        //                 {
                        //                     name: item.serialNumber,
                        //                     data: c,
                        //                 }
                        //             )
                        //         ]
                        //     )
                        //     c = [];
                        //     // nullFilter(analytics, 'current', analytics.messages.current)
                        // }).then(() => {
                        //     setIsCurrent(true);
                        //     // powerChart();
                        // })
                    })

                    if (isVoltage && isCurrent) {
                    }
                    // gt(item.name, firstTime, lastTime).then(() => {
                    //     setChartData(
                    //         [
                    //             ...chartData,
                    //             chartData[2].data.push(
                    //                 {
                    //                     name: item.serialNumber,
                    //                     data: t,
                    //                 }
                    //             )
                    //         ]
                    //     )
                    //     // nullFilter(analytics, 'temperature', analytics.messages.temperature)
                    //     setIsTemperature(true)
                    // })
                    // gh(item.name, firstTime, lastTime).then(() => {
                    //     setChartData(
                    //         [
                    //             ...chartData,
                    //             chartData[3].data.push(
                    //                 {
                    //                     name: item.serialNumber,
                    //                     data: h,
                    //                 }
                    //             )
                    //         ]
                    //     )
                    //     // nullFilter(analytics, 'humidity', analytics.messages.humidity)
                    //     setIsHumidity(true)
                    // })
                })
            } else {
                navigate('/auth')
            }
        })
    }, [analytics.fetchList, firstTime | lastTime]);


    return (
        <>
            <h1>Аналитика</h1>
            <div className={classes.container}>
                <div className={classes.graphics}>
                    <div className={classes.timeStep}>
                        <button className={classes.arrow} onClick={() => {
                            let r = lastTime.diff(firstTime);
                            let d = dayjs(lastTime).subtract(r)
                            setLastTime(d)
                            let a = dayjs(firstTime).subtract(r)
                            setFirstTime(a)
                        }}><Icon path={mdiChevronLeft} size={2}/></button>
                        <DateAndTimePicker>
                            <DateTimePicker viewRenderers={null}
                                            format={'YYYY-MM-DD HH:mm'}
                                            minDateTime={dayjs('2024-01-26T00:00')}
                                            maxDateTime={dayjs()}
                                            ampm={false} label="Начало"
                                            value={firstTime}
                                            onChange={(newValue) => {
                                                setFirstTime(newValue)
                                                setRange(24)
                                            }}/>
                            <DateTimePicker viewRenderers={null}
                                            format={'YYYY-MM-DD HH:mm'}
                                            minDateTime={firstTime}
                                            maxDateTime={maxLastTime}
                                            ampm={false} label="Конец"
                                            value={lastTime}
                                            onChange={(newValue) => setLastTime(newValue)}/>
                        </DateAndTimePicker>
                        <button style={{marginLeft: '1rem'}} className={classes.arrow} onClick={() => {
                            let r = lastTime.diff(firstTime);
                            let d = dayjs(lastTime).add(r)
                            if (d > dayjs()) {
                                d = dayjs()
                                setMaxLastTime(d)
                            }
                            setLastTime(d)
                            setFirstTime(d.subtract(r))
                        }}><Icon path={mdiChevronRight} size={2}/></button>
                        <button className={classes.changeTime} onClick={() => {
                            updateFirstTime(2)
                        }}>2 часа
                        </button>
                        <button className={classes.changeTime} onClick={() => {
                            updateFirstTime(12)
                        }}>12 часов
                        </button>
                        <button className={classes.changeTime} onClick={() => {
                            updateFirstTime(24)
                        }}>24 часа
                        </button>
                    </div>
                    {/*{chartData.map((item) => {*/}
                    {/*    return <ChartStacked*/}
                    {/*        key={item.id}*/}
                    {/*        color={'red'}*/}
                    {/*        unit={item.unit}*/}
                    {/*        title={item.name}*/}
                    {/*        data={item.data}*/}
                    {/*        ui={true}*/}
                    {/*        isFetch={item.isFetch}*/}
                    {/*    />*/}
                    {/*})}*/}
                    <ChartStacked
                    data={chartData[0].data}
                    color={'red'}
                    unit={chartData[0].unit}
                    title={chartData[0].name}
                    ui={true}
                    isFetch={isVoltage}
                    id={1}

                    />

                </div>
            </div>
        </>
    );
});

export default Analytics;